import { Typography, Link, Feedback, Spacer, Box } from '@telus-uds/components-web';

export const mdCompsMapping = {
    a: ({href, children}) => <Link href={href} hrefAttrs={{target: '_blank'}}>{children}</Link>,
    h1: ({children}) => <Box vertical={3} tokens={{backgroundColor: 'transparent'}}><Typography variant={{ size: 'h1' }} tag="h1">{children}</Typography></Box>,
    h2: ({children}) => <Box vertical={3} tokens={{backgroundColor: 'transparent'}}><Typography variant={{ size: 'h2' }} tag="h2">{children}</Typography></Box>,
    h3: ({children}) => <Box vertical={2} tokens={{backgroundColor: 'transparent'}}><Typography variant={{ size: 'h3', colour: 'default' }} tag="h3">{children}</Typography></Box>,
    h4: ({children}) => <Box vertical={1} tokens={{backgroundColor: 'transparent'}}><Typography variant={{ size: 'h4' }} tag="h4">{children}</Typography></Box>,
    p: ({children}) => <Box vertical={1} tokens={{backgroundColor: 'transparent'}}><Typography variant={{ size: 'medium' }} tag="p">{children}</Typography></Box>,
    blockquote: ({children}) => <Feedback tag="blockquote">{children}</Feedback>,
    hr: () => <Spacer space={3} />,
    img: ({src, alt}) => <img src={src} alt={alt} style={{maxWidth: '100%', maxHeight: '50vh'}} />,
}

export const mdDisclaimerCompsMapping = {
    a: ({href, children}) => <Link href={href} hrefAttrs={{target: '_blank'}} variant={{ size: 'micro' }}>{children}</Link>,
}